import { objectToQueryString } from "../../../helpers/objectToQueryString";
import { API } from "../../api";
async function getCustomContents(request) {
    return await new API().apiGet({
        baseUrl: process.env.LETS_TRADE_CLIENT_URL ?? "",
        endpoint: `v2/custom-contents${objectToQueryString(request)}`,
    });
}
export { getCustomContents };
